var SERVER_URL = "https://i13hpc29.iar.kit.edu/api/";
const MOCK_BACKEND = false;

export { SERVER_URL, MOCK_BACKEND };